export default "__VITE_ASSET__CF93gxls__"